export default __webpack_public_path__ + "static/media/marauders-map-v4-04-03.2c710ef5.jpg";